import { setHeaders } from "../utils/fetch";

function update(pinwall, user) {
  return new Promise((resolve, reject) => {
    fetch(
      `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/pinwall/${
        pinwall.id
      }`,
      {
        method: "put",
        headers: setHeaders(
          {
            "Content-Type": "application/json"
          },
          user
        ),
        body: JSON.stringify(pinwall)
      }
    )
      .then(res => {
        return res.json();
      })
      .then(function(data) {
        resolve(data);
      })
      .catch(e => {
        window.console.error(e);
        reject();
      });
  });
}

export { update };
